/**
 * @module fluent
 * @overview
 *
 * `fluent` is a JavaScript implementation of Project Fluent, a localization
 * framework designed to unleash the expressive power of the natural language.
 *
 */
export { FluentBundle } from "./bundle.js";
export { FluentResource } from "./resource.js";
export { FluentType, FluentNone, FluentNumber, FluentDateTime, } from "./types.js";
